"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let WComment = class WComment extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "modal",
    };
    beforeCreate() {
    }
    parentId;
    onParent_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parentId");
    }
    parent;
    onParent(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parent");
    }
    container;
    onContainer(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("container");
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    resource;
    async $$load_resource() {
        return this.item || this.$fn.schemaDefaults('CreateComment', { object_id: this.parentId || this.parent.id });
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    createTitle;
    editTitle;
    ux;
    dataMembers = ['resource', 'editor', 'createTitle', 'editTitle', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                resource: null,
                editor: null,
                createTitle: this.$fn.pgettext("Comments", "Add comment"),
                editTitle: this.$fn.pgettext("Comments", "Edit comment"),
                ux: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.item == null == null ? this.createTitle : this.editTitle,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2688_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeComponent_2694_getActionArgs($event) {
        return {
            result: {
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_closeComponent_2696_getActionArgs($event) {
        return {
            result: {},
        };
    }
    async act_1040167445267876_rest_2692_getActionArgs($event) {
        return {
            method: "save",
            container: this.container,
            resource: this.editor,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2688 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2688_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2687 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2688,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2687],
        });
        const act_2248226175642056_closeComponent_2690 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_2689 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_2690,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_2689],
        });
        const act_1040167445267876_closeComponent_2694 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_2694_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_2693 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_2694,
            event: "saved",
            displayName: "closeComponent",
        });
        const act_1040167445267876_closeComponent_2696 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_2696_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_deleted_2695 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_2696,
            event: "deleted",
            displayName: "closeComponent",
        });
        const act_1040167445267876_rest_2692 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_2692_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_saved_2693, evh_1040167445267876_deleted_2695],
        });
        const evh_1040167445267876_submit_2691 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_2692,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_2691],
        });
        const act_1419464017721962_closeComponent_2698 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_2697 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_2698,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_2697],
        });
        return {
            act_7315092382398562_closeModal_2688,
            evh_7315092382398562_close_2687,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_2690,
            evh_2248226175642056_close_2689,
            evh_2248226175642056_close,
            act_1040167445267876_closeComponent_2694,
            evh_1040167445267876_saved_2693,
            act_1040167445267876_closeComponent_2696,
            evh_1040167445267876_deleted_2695,
            act_1040167445267876_rest_2692,
            evh_1040167445267876_submit_2691,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_2698,
            evh_1419464017721962_clickPreventStop_2697,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_rest_2692,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], WComment.prototype, "parentId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parentId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WComment.prototype, "onParent_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], WComment.prototype, "parent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WComment.prototype, "onParent", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], WComment.prototype, "container", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('container'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WComment.prototype, "onContainer", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], WComment.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WComment.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], WComment.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WComment.prototype, "onSize", null);
WComment = __decorate([
    (0, vue_property_decorator_1.Component)()
], WComment);
exports.default = WComment;
vue_property_decorator_1.Vue.component("WComment", WComment);
